import { setLocale } from 'yup'

const setFormValidationMessages = () => {
	setLocale({
		mixed: {
			required: 'formError.required'
		},
		string: {
			email: 'formError.email'
		}
	})
}

export default setFormValidationMessages
